import React from 'react';
import '../css/App.css';
import '../css/Product.css';
import ls from 'local-storage'
import urls from '../configs/urls'
import axios from 'axios';
import {
    BrowserView,
    MobileView,
} from "react-device-detect";

import {Redirect, withRouter} from "react-router";
import Khadamati from "../Modules/Khadamati";
import Retry from "./Retry";
import AppBody from "./AppBody";
class CategoryOfService extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            services:[],
        };
    }

    componentDidMount = () => {
       this.getCategoryList();
    };

    render() {
        if(this.state.redirect)
            return (<Redirect push to={this.state.url}/>);
        if(this.state.retry)
            return (<Retry url={"/home"} type={"RELOAD"} text={"در اجرای درخواست مشکلی پیش آمده است. لطفا مجددا تلاش کنید."}/>);
        if(this.state.error)
            return (
                <div className="App-body bg-white">
                    <div className={"infoMessage"}>
                        {this.state.error_text}
                    </div>
                    <form onSubmit={this.handleSubmit}>
                        <input type={"submit"} className={"btn submitPhone"} value={"صفحه اصلی"}/>
                    </form>
                </div>
            );
       return(
           <AppBody loading={this.state.loading} name={"خدماتی"} type={" alice"} hasSlider={true}>
               <div id={"serviceItems"}>
                   {this.state.services.map((item)=>{
                       return(
                           <div className={"serviceItemElm"} >
                               <div className={"serviceItemImgElm"} onClick={()=>{ls.set("service_id",item.id);this.props.history.push("/service");}}>
                                   <img className={"serviceItemImg"} src={urls.SiteUrl+"upload/"+item.img}/>
                               </div>
                               <div className={"serviceItemText"}>{item.title}</div>
                               <BrowserView><div className={"serviceItemText"}>{item.phone}</div></BrowserView>
                               <MobileView><a href={"tel:"+item.phone} className={"btn btn-success servicePhone"}><i className="serviceItemText glyphicon glyphicon-earphone"/></a></MobileView>
                           </div>
                       );
                   })}
               </div>
           </AppBody>
       );
    }

    getCategoryList(){
        console.log("STARTED",ls.get("category_service_id"));

        if(ls.get("category_service_id") == null)
            return;
        this.setState({loading:true});
        axios.get(urls.baseUrl+urls.listkhadamati+"?id="+ls.get("category_service_id"))
            .then(res => {
                console.log("SERVIECE : ",this.state.category_service_id);
                if(res.data.code == 200){
                    let services = [];
                    res.data.khadamati.forEach((item)=>{
                        services.push(new Khadamati(item));
                    });
                    console.log("SERVIECE : ",services);
                    this.setState({
                        services:services,
                        loading:false
                    });
                }
                else{
                    alert(res.data.message())
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({retry:true,loading:false});
            });
    }


}

export default withRouter(CategoryOfService);
